import type { ComponentProps } from 'react';

import { Button } from '@/lib/shadcn/button';
import { cn } from '@/lib/utils';

type PrimaryVariant = 'default' | 'success' | 'info' | 'destructive' | 'warning';

// Overrides the shadcn variant prop with our semantic set.
// All variants are theme-aware via CSS custom properties in globals.scss.
interface PrimaryButtonProps extends Omit<ComponentProps<typeof Button>, 'variant'> {
  variant?: PrimaryVariant;
}

const variantClass: Record<PrimaryVariant, string> = {
  default: '',
  success: 'bg-success text-success-foreground hover:bg-success/90',
  info: 'bg-info text-info-foreground hover:bg-info/90',
  destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
  warning: 'bg-warning text-white hover:bg-warning/90',
};

export function PrimaryButton({ variant = 'default', className, ...props }: PrimaryButtonProps) {
  return <Button className={cn(variantClass[variant], className)} {...props} />;
}
